import React, { Component } from 'react';
import { Grid, Form } from 'semantic-ui-react';
import { Field, reduxForm, FormSection } from 'redux-form';
import { APPLICATION_HOH_FORM_NAME } from 'Common/FormEnum';
import { InputField } from 'Common/SemanticWrapper';
import { ApplicationFieldEnum as Fields } from 'Common/FieldEnum';
import { IncomeForm } from '../hub/IncomeForm';
import { validateIncome } from '../../helpers/validation/IncomeValidator';
import { LanguageSsnForm } from './HOHLanguageSSNForm';
import { TitledCard } from 'Components';

class HoHForm extends Component {
  static path = '/manageapplication/:familyId/hoh/';

  onBackClick = (e, showDirtyLinkConfirm) => {
    e.preventDefault();
    showDirtyLinkConfirm(`/manageapplication/${this.props.familyId}`);
  };

  render() {
    const { handleSSNChange, handleNoSSNChange } = this.props;
    return (
      <Form>
        <TitledCard title={'Information'}>
          <Grid>
            <Grid.Row>
              <Grid.Column width={5}>
                <Field
                  component={InputField}
                  label={'First Name'}
                  maxLength={20}
                  name={Fields.FirstName}
                />
              </Grid.Column>
              <Grid.Column width={5}>
                <Field
                  component={InputField}
                  label={'Last Name'}
                  maxLength={20}
                  name={Fields.LastName}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
          <LanguageSsnForm
            handleSSNChange={handleSSNChange}
            handleNoSSNChange={handleNoSSNChange}
          />
        </TitledCard>
        <FormSection name="Income">
          <IncomeForm memberName={'Head of Household'} />
        </FormSection>
      </Form>
    );
  }
}

const validate = (values, ownProps) => {
  const errors = {};

  if (!values[Fields.FirstName] || values[Fields.FirstName].trim().length < 1) {
    errors[Fields.FirstName] = 'Please enter a first name.';
  }

  if (!values[Fields.LastName] || values[Fields.LastName].trim().length < 1) {
    errors[Fields.LastName] = 'Please enter a last name.';
  }

  if (
    values[Fields.SSN] &&
    values[Fields.SSN] !== undefined &&
    values[Fields.SSN].length > 0 &&
    values[Fields.SSN].length < 4
  ) {
    errors[Fields.SSN] = 'Please enter a valid SSN.';
  }

  errors.Income = validateIncome(values.Income);

  return errors;
};

export default reduxForm({
  validate,
  form: APPLICATION_HOH_FORM_NAME,
  destroyOnUnmount: true,
  enableReinitialize: true,
})(HoHForm);



// WEBPACK FOOTER //
// ./src/pages/manageapplication/components/hoh/HoHForm.js